import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorProvider } from './context/ErrorContext'; // Adjust the path if needed
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import './index.css';
import './styles/vehicle-modern.css';
import './styles/app-modern.css';
import { registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorProvider>
    <App />
  </ErrorProvider>
);
registerServiceWorker();
